module.exports = __webpack_public_path__ + "static/img/S124_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S124_1.png
// module id = 8dmo
// module chunks = 0